:host {
    flex-shrink: 1;

    height: 100%;
    width: 100%;
    
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;

    @warn('update');

    @keyframes blink {
        0% {
            opacity: 1;
        }
        50% {
            opacity: 0;
        }
    }
    .data-loading {
        animation: blink 3s ease-in-out infinite;
    }
}
